import React from 'react';
import TopBar from './TopBar';
import Footer from './Footer';
import '../styles/Layout.scss';

interface LayoutProps {
  children: React.ReactNode;
  isAdmin?: boolean;
  brandAirlines?: string[];
}

const Layout: React.FC<LayoutProps> = ({ children, isAdmin = false, brandAirlines = [] }) => {
  return (
    <div className="layout">
      <TopBar isAdmin={isAdmin} brandAirlines={brandAirlines} />
      <main className="layout-body">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
